export default __webpack_public_path__ + "static/media/debate_25.6a47994d.JPG";